export function compileInputHandler(
  inputHandlerBody: string
): string {
  return `(value, tag, outputs, state, params) => {
  ${inputHandlerBody} 
}`;
}
